import { environment } from '../../../../environments/environment';

export class CompanyWorkingHours {
  private _indexDayOfWeek: number;
  private _fromTime: number;
  private _toTime: number;

  constructor(
    indexDayOfWeek: number,
    fromTime: number,
    toTime: number,
  ) {
    this._indexDayOfWeek = indexDayOfWeek;
    this._fromTime = fromTime;
    this._toTime = toTime;
  }

  static createFromAny(object: any): CompanyWorkingHours {
    if (object === null || object === undefined) {
      return null;
    }

    return new CompanyWorkingHours(
      object.indexDayOfWeek,
      object.fromTime,
      object.toTime,
    );
  }

  get indexDayOfWeek(): number {
    return this._indexDayOfWeek;
  }

  get fromTime(): number {
    return this._fromTime;
  }

  get toTime(): number {
    return this._toTime;
  }

  get openHours(): string {
    if (this._fromTime && this._toTime) {
      return environment.globalSettings.toTimeString(this._fromTime) + '-' + environment.globalSettings.toTimeString(this._toTime);
    } else {
      return 'Closed';
    }

  }
}
